import { render, staticRenderFns } from "./DeveloperPortal.vue?vue&type=template&id=e0254a3e&scoped=true"
import script from "./DeveloperPortal.vue?vue&type=script&lang=js"
export * from "./DeveloperPortal.vue?vue&type=script&lang=js"
import style0 from "./DeveloperPortal.vue?vue&type=style&index=0&id=e0254a3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0254a3e",
  null
  
)

export default component.exports